import { mapState } from "../../store/map";
export default {
  name: "TagList",
  setup: function setup() {
    window.scrollTo({
      top: 0
    });

    var _mapState = mapState("tagAbout"),
        tagCounts = _mapState.tagCounts;

    return {
      tagCounts: tagCounts
    };
  }
};